<template>
  <div class="orderDt">
    <van-nav-bar :title="title" 
      left-arrow
      @click-left="onClickLeft"
      class="topBar"
    />
    <div style="height:45px"></div>
    <div class="van-cell setBox noLine gdItem" v-for="(item,index) in yhList" :key="index" @click="goXf(item)"  >
      <div class="flex1 setBox noLine">
        <div class="flex1">
          <font class="orderNum cptit"><b>{{item.deptname}}</b> </font>
          <font class="status">
              <div class="point "></div>
              {{item.name}}
              <van-icon name="arrow" class="rightBtn"/>
          </font>
        </div>
        <!-- <div class="flex1">
          等级：{{item.yhdj}}
        </div>
        <div class="flex1">
          提报人：{{item.tbr}}
        </div>
        <div class="flex1">
          检查时间：{{item.jcrq}}
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import _URL from "../../lib/url";
  import { Toast, Dialog, RadioGroup, Radio, PullRefresh } from "vant";
  import { getAction, postAction } from "@/api/manage";
  export default {
    name: "index",
    data: function () {
      return {
          activeName: '报警器列表',
          title: '报警器列表',
          yhList:[],
      };
    },
    mounted: function () {
      let that = this;
      //获取巡检列表
      that.getList()
      let active =  localStorage.getItem('active')
      if(!active){
        active = 0
      }
      that.activeName = active;
    },
    methods: {
      goXf(item){
        let that = this
        that.$router.push({
          path:'sbfxShow',
          query:{
            type:'3',
            showBtn:true,
            title:'实时分析',
            id:item.id,
            djbh:item.name,
            deptname:item.deptname
          }
        });
      },
      getList(){
          let that = this;
          let obj = {
            userid:localStorage.getItem('uid'),
            pageNum:1,
            pageSize:10000
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(`${_URL.sbList}`, obj).then((res) => {
            console.log(JSON.stringify(res));
            Toast.clear();
            const sbArr = res.data.rows.filter(item => item.money!= '报警灯');
            that.yhList = sbArr;
          });
      },
      ckActve(avtive){
          localStorage.setItem('active',avtive)
      },
      onClickLeft: function() {
        this.$router.go(-1);
      },
    },
  };
</script>
<style lang="less">
  .orderDt{
    .rightBtn{
        font-size:20px;
        position: relative;
        float: right;
        top:2px;
        margin-left:10px
    }
    .cptit{
        font-size:17px;
    }
    .progressd{
        width:90%;
        margin-left:5%;
    }
    .progs{
        position: relative;
        top:11px
    }
    .van-tabs__line{
      background-color: #1773f8;
    }
  }
</style>
  
  